import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { PessoaContatoComponent } from './pessoa-contato.component';
import { PessoaContatoFilterComponent, PessoaContatoFilterPipe } from './filter';
import { PessoaContatoTableComponent } from './table';
import { PessoaContatoFormComponent } from './form';
import { PessoaContatoFormModalComponent } from './form-modal';
import { PessoaContatoUnicoComponent } from './unico';
import { PessoaContatoPipelineCardComponent } from './pipeline-card';
import { PessoaContatoTipoMultiselectComponent, PessoaContatoTipoPipe, PessoaContatoTipoSortPipe, PessoaContatoTipoPrimarioPipe, PessoaContatoTipoSequenciaPrimarioPipe } from './tipo';
import { PessoaContatoSituacaoMultiselectComponent, PessoaContatoSituacaoPipe, PessoaContatoSituacaoIconPipe, PessoaContatoSituacaoBadgePipe } from './situacao';
import { PessoaContatoPrimarioFilterPipe } from './pipes';
import { PessoaContatoDropdownInsertComponent } from './dropdown-insert';
import { PessoaContatoListGroupComponent } from './list-group';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        PessoaContatoComponent,
        PessoaContatoFilterComponent,
        PessoaContatoTableComponent,
        PessoaContatoFormComponent,
        PessoaContatoFormModalComponent,
        PessoaContatoUnicoComponent,
        PessoaContatoPipelineCardComponent,
        PessoaContatoTipoMultiselectComponent,
        PessoaContatoSituacaoMultiselectComponent,
        PessoaContatoDropdownInsertComponent,
        PessoaContatoListGroupComponent,

        // Pipes
        PessoaContatoFilterPipe,
        PessoaContatoTipoPipe,
        PessoaContatoTipoSortPipe,
        PessoaContatoTipoPrimarioPipe,
        PessoaContatoTipoSequenciaPrimarioPipe,
        PessoaContatoSituacaoPipe,
        PessoaContatoSituacaoIconPipe,
        PessoaContatoSituacaoBadgePipe,
        PessoaContatoPrimarioFilterPipe
    ],
    exports: [
        PessoaContatoComponent,
        PessoaContatoUnicoComponent,
        PessoaContatoPipelineCardComponent,
        PessoaContatoFormModalComponent,
        PessoaContatoDropdownInsertComponent,
        PessoaContatoListGroupComponent,

        // Pipes
        PessoaContatoTipoPipe,
        PessoaContatoTipoSortPipe,
        PessoaContatoTipoPrimarioPipe,
        PessoaContatoTipoSequenciaPrimarioPipe,
        PessoaContatoSituacaoPipe,
        PessoaContatoSituacaoIconPipe,
        PessoaContatoSituacaoBadgePipe,
        PessoaContatoPrimarioFilterPipe
    ],
    providers: [
        PessoaContatoFilterPipe,
        PessoaContatoTipoPipe,
        PessoaContatoTipoSortPipe,
        PessoaContatoTipoPrimarioPipe,
        PessoaContatoTipoSequenciaPrimarioPipe,
        PessoaContatoSituacaoPipe,
        PessoaContatoSituacaoIconPipe,
        PessoaContatoSituacaoBadgePipe,
        PessoaContatoPrimarioFilterPipe
    ]
})
export class PessoaContatoModule { }
